import { destroy } from '@alltrails/core/utils/destroy';
import { post } from '@alltrails/core/utils/post';
import type { Track, TrackId } from '@alltrails/types/Track';
import type { TrailId } from '@alltrails/types/TrailId';

export function removeTrack(trackId: TrackId) {
  return post(`/api/alltrails/maps/${trackId}/remove`, undefined);
}

export function deleteTrack(trackId: TrackId) {
  return destroy(`/api/alltrails/maps/${trackId}`);
}

export function setTrackAsVerified(track: Track, trailId: TrailId) {
  const trackTrailId = track.trailId ?? trailId;

  return post(`/api/alltrails/maps/${track.id}/verify`, undefined, {
    params: { trail_id: trackTrailId, use_contrib: true, preserve_trail_waypoints: true, ignore_map_waypoints: true }
  });
}

export function updateTrackMetadata(trackId: TrackId, data) {
  return post(`/api/alltrails/maps/${trackId}/metadata`, data);
}
